'use strict';

module.exports = {
    general: require('./generalMatcher'),
    msem: require('./msemMatcher')
};



// WEBPACK FOOTER //
// ./node_modules/mf-matcher/src/index.js